// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let V4 = require("uuid/v4");
let DateFns = require("date-fns");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Link = require("next/link").default;
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let ConfirmDialog = require("../../reason/common/ConfirmDialog/ConfirmDialog.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MyDraftsWidgetDraftListItem_draft_graphql = require("../../__generated__/MyDraftsWidgetDraftListItem_draft_graphql.bs.js");
let MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql = require("../../__generated__/MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.bs.js");

let convertFragment = MyDraftsWidgetDraftListItem_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_draftOrigin_decode = MyDraftsWidgetDraftListItem_draft_graphql.Utils.draftOrigin_decode;

let DraftFragment_draftOrigin_fromString = MyDraftsWidgetDraftListItem_draft_graphql.Utils.draftOrigin_fromString;

let DraftFragment = {
  draftOrigin_decode: DraftFragment_draftOrigin_decode,
  draftOrigin_fromString: DraftFragment_draftOrigin_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyDraftsWidgetDraftListItem$ConfirmDeleteDialog(props) {
  let onCancel = props.onCancel;
  let onConfirm = props.onConfirm;
  return JsxRuntime.jsx(ConfirmDialog.make, {
    title: "Delete Draft?",
    ariaLabel: "Confirm Delete Draft",
    body: JsxRuntime.jsx(JsxRuntime.Fragment, {
      children: JsxRuntime.jsx("div", {
        children: "This will delete the draft and cannot be undone.",
        className: "leading-normal"
      })
    }),
    isOpen: props.isOpen,
    onCancel: onCancel,
    cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
      onClick: param => onCancel(),
      children: "No, Keep Draft"
    }),
    confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
      onClick: param => onConfirm(),
      children: "Yes, Delete Draft"
    })
  });
}

let ConfirmDeleteDialog = {
  make: MyDraftsWidgetDraftListItem$ConfirmDeleteDialog
};

function MyDraftsWidgetDraftListItem$DeleteDraftButton(props) {
  let onDelete = props.onDelete;
  let match = React.useState(() => false);
  let setIsOpen = match[1];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(MyDraftsWidgetDraftListItem$ConfirmDeleteDialog, {
        isOpen: match[0],
        onConfirm: () => {
          setIsOpen(param => false);
          onDelete();
        },
        onCancel: () => setIsOpen(param => false)
      }),
      JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
        onClick: param => setIsOpen(param => true),
        disabled: props.disabled,
        size: "small",
        children: [
          JsxRuntime.jsx(IconV5.make, {
            icon: "trash"
          }),
          JsxRuntime.jsx("div", {
            className: "ml-[8px]"
          }),
          "Delete"
        ]
      })
    ]
  });
}

let DeleteDraftButton = {
  make: MyDraftsWidgetDraftListItem$DeleteDraftButton
};

let convertVariables = MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.Internal.convertVariables;

let convertResponse = MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let DeleteDraftV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function MyDraftsWidgetDraftListItem(props) {
  let listConnectionId = props.listConnectionId;
  let draft = RescriptRelay_Fragment.useFragment(MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment, props.draft);
  let match = use$1();
  let deleteDraft = match[0];
  let match$1 = draft.origin;
  let draftLink;
  if (match$1 !== undefined) {
    let exit = 0;
    if (match$1 === "BROADCAST_QUIET_SELLER" || match$1 === "REBROADCAST" || match$1 === "NEW") {
      switch (match$1) {
        case "NEW" :
          draftLink = "/properties/new?draftId=" + draft.databaseId;
          break;
        case "BROADCAST_QUIET_SELLER" :
        case "REBROADCAST" :
          exit = 1;
          break;
      }
    } else {
      draftLink = "#";
    }
    if (exit === 1) {
      let match$2 = draft.publishedProperty;
      draftLink = match$2 !== undefined ? `/properties/` + match$2.id + `/broadcast?resumingDraft=1` : "#";
    }
  } else {
    draftLink = "#";
  }
  let match$3 = draft.draftProperty;
  let text;
  if (match$3 !== undefined) {
    let address = match$3.address;
    let match$4 = Stdlib_Option.map(match$3.userSelectedArea, v => v.name);
    text = address !== undefined ? (
        match$4 !== undefined ? address + (", " + match$4) : address
      ) : (
        match$4 !== undefined ? match$4 : "(no address entered)"
      );
  } else {
    text = "(no address entered)";
  }
  let match$5 = SystemMessages.useSystemMessages();
  let addMessage = match$5.addMessage;
  let match$6 = draft.origin;
  let tmp;
  if (match$6 !== undefined && (match$6 === "BROADCAST_QUIET_SELLER" || match$6 === "REBROADCAST" || match$6 === "NEW")) {
    switch (match$6) {
      case "BROADCAST_QUIET_SELLER" :
        tmp = "Quiet Property Broadcast";
        break;
      case "NEW" :
        tmp = "New Broadcast";
        break;
      case "REBROADCAST" :
        tmp = "Rebroadcast";
        break;
    }
  } else {
    tmp = "";
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs(Link, {
            href: draftLink,
            className: "flex flex-col gap-1",
            children: [
              JsxRuntime.jsx("div", {
                children: tmp,
                className: "text-gray-500 text-sm font-semibold uppercase tracking-wide"
              }),
              JsxRuntime.jsx("div", {
                children: text,
                className: "text-lg font-medium"
              })
            ]
          }),
          JsxRuntime.jsx("div", {
            children: DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(draft.updatedAt)), "MM/dd/yyyy"),
            className: "my-2 md:my-0"
          })
        ],
        className: "col-span-12 lg:col-span-6 flex flex-col md:flex-row md:justify-between md:items-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
            href: draftLink,
            size: "small",
            children: [
              JsxRuntime.jsx(IconV5.make, {
                icon: "pencil",
                size: 15
              }),
              JsxRuntime.jsx("div", {
                className: "ml-[8px]"
              }),
              "Resume"
            ]
          }),
          JsxRuntime.jsx(MyDraftsWidgetDraftListItem$DeleteDraftButton, {
            onDelete: () => {
              deleteDraft({
                connections: Stdlib_Array.keepSome([listConnectionId]),
                input: {
                  draftId: draft.databaseId
                }
              }, undefined, undefined, undefined, (response, param) => {
                let match = response.deleteDraftV5;
                if (match !== undefined && match.__typename === "DraftWasDeleted") {
                  return addMessage(SystemMessages.Message.make(V4(), "info", "The draft was deleted.", 5000, undefined, undefined));
                }
                addMessage(SystemMessages.Message.make(V4(), "error", "There was a problem deleting your draft.", 5000, undefined, undefined));
              }, undefined, undefined);
            },
            disabled: match[1]
          })
        ],
        className: "col-span-12 lg:col-span-6 text-right flex flex-row space-x-2 md:justify-end items-center"
      })
    ],
    className: "grid grid-cols-12 gap-2 py-4 border-t"
  });
}

let make = MyDraftsWidgetDraftListItem;

exports.DraftFragment = DraftFragment;
exports.ConfirmDeleteDialog = ConfirmDeleteDialog;
exports.DeleteDraftButton = DeleteDraftButton;
exports.DeleteDraftV5Mutation = DeleteDraftV5Mutation;
exports.make = make;
/* commitMutation Not a pure module */
